// extracted by mini-css-extract-plugin
module.exports = {"article":"Documents_article__2saDC","info":"Documents_info__2ybu7"};